import { takeLatest, put, all, select, call } from 'redux-saga/effects';
import moment from 'moment-timezone';
import * as commonTypes from '@store/common/types';
import { setComparisonInterval } from '@store/summaryContainer/comparison/actions';
import { toggleDiagChart } from '@store/dimensionContainer/actions';
import { featureSelector, selectedCustomerIdSelector } from '@store/common/selectors';
import { updateInterval } from '@store/common/actions';
import { DATE_SHORTCUTS, DEFAULT_GLOBAL_ACCOUNT, isOdpModule } from '@utils/constants';
import featureNames from '@utils/featureToggle/constants';
import { calcShortcutInterval } from '@utils';
import { calcComparisonInterval } from '../../components/summary-panel/SummaryContainer/utils/dates';
import { sagas as sharing } from './sharing';
import { sagas as birdChart } from './birdChart';
import { sagas as distribution } from './distribution';
import { sagas as tempSagas } from './tempDashboard';
import { sagas as baseSagas } from './base';
import { sagas as dashboardSagas } from './dashboard';
import { toggleShowAlerts, setSelectedEvent } from './alerts/actions';
import { initChart } from './birdChart/actions';
import { RESET, SAVE_STATE } from './types';
import { changeMode } from './actions';
import { updateState } from './sharing/sagas';
import { MODE_TRENDS } from './constants';
import { setSharedState } from './base/actions';
import { resetAiAlertState } from './aiAlerts/actions';

let trendsState = null;

// reset has to run before persistence
function* init() {
  let [from, to] = calcShortcutInterval(DATE_SHORTCUTS.last6Hours);
  const selectedCustomerId = yield select(selectedCustomerIdSelector);
  /**
   * GLOBAL ACC requires default data loading time to be last24hours
   * This is a border case to be added for PII request
   */
  if (selectedCustomerId == DEFAULT_GLOBAL_ACCOUNT) {
    [from, to] = calcShortcutInterval(DATE_SHORTCUTS.past24Hours);
  }
  const durationAllowed = yield select(featureSelector(featureNames.DATA_ACCESS_DURATION));
  const { from: compareFrom, to: compareTo } = calcComparisonInterval(
    { from, to, shortcut: DATE_SHORTCUTS.last6Hours },
    durationAllowed,
  );
  const fromSeconds = moment(from).seconds();
  const toSeconds = moment(to).seconds();
  compareFrom.seconds(fromSeconds);
  compareTo.seconds(toSeconds);

  const tasks = [
    put(setComparisonInterval(compareFrom.format(), compareTo.format())),
    put(toggleShowAlerts(false)),
    put(setSelectedEvent(null)),
    put(resetAiAlertState()),
    put({ type: commonTypes.RESET }),
    put(initChart()),
    put(toggleDiagChart(false)),
    // workaround, WithReset needs to be cleaned up
    put(isOdpModule ? { type: 'noop' } : setSharedState({})),
    put(updateInterval(from.format(), to.format(), DATE_SHORTCUTS.last6Hours, 'trends')),
    put(changeMode(MODE_TRENDS)),
  ];

  yield all(tasks);
}

function* reset(action) {
  if (trendsState) {
    yield call(updateState, trendsState);
    yield put(changeMode(MODE_TRENDS));
  } else {
    yield call(init);
  }

  if ('doneCallback' in action) {
    action.doneCallback();
  }
}

function save({ state }) {
  trendsState = state;
}

function* watchReset() {
  yield takeLatest([RESET], reset);
}

function* watchSave() {
  yield takeLatest([SAVE_STATE], save);
}

export default [
  watchReset,
  watchSave,
  ...sharing,
  ...birdChart,
  ...distribution,
  ...tempSagas,
  ...baseSagas,
  ...dashboardSagas,
];
